var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.userName)?_c('div',{staticClass:"user-info"},[_c('span',[_vm._v("用户名称："+_vm._s(_vm.userName))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }